exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".messages[data-v-47ea0f69] {\n  width: 1050px;\n  max-width: 100%;\n  margin: 0 auto;\n}\n.flex-right[data-v-47ea0f69] {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.ml-20[data-v-47ea0f69] {\n  margin-left: 20px;\n}", ""]);

// exports
